import { agPriceCol } from '@/ag-grid/ag-columns'
import { notAnyPriceCheck } from '@/ag-grid/utils/notAnyValue'

export default {
  computed: {
    gridOptions() {
      return {
        columnDefs: [
          {
            headerName: 'Name',
            field: 'name',
            tooltipField: 'name',
            sort: 'asc',
            cellRendererFramework: 'LinkRenderer',
            cellRendererParams: params => {
              return {
                route: `/products/${params.data.id}`
              }
            }
          },

          agPriceCol('Subscriptions', 'subscriptions_count', {
            cellRenderer: params => params.value ?? 0,
            maxWidth: undefined
          }),

          agPriceCol('Publications in latest title list', 'latest_title_list_publications_count', {
            cellRenderer: params => params.value ?? 0,
            maxWidth: undefined
          }),

          agPriceCol('Total value original currency', 'total_value_original_currency', {
            cellRenderer: params => notAnyPriceCheck(params, 'subscription_value_original_currency'),
            maxWidth: undefined
          }),

          agPriceCol('Total value local currency', 'subscription_value_local', {
            cellRenderer: params => notAnyPriceCheck(params, 'subscription_value_local_currency'),
            maxWidth: undefined
          })
        ],

        rowModelType: 'serverSide',
        serverSideStoreType: 'partial',
        cacheBlockSize: 40
      }
    }
  }
}
